module.exports = __webpack_public_path__ + "img/slic_04.09c579dc.png";